import {
  ReportSubscriptionFrequency,
  ReportSubscriptionType,
} from '@/@types/report-subscription';

export const REPORT_SUBSCRIPTION_TYPE_LABELS: Record<
  ReportSubscriptionType,
  string
> = {
  'daily-sales-summary': 'Resumo diário de vendas',
  'weekly-sales-summary': 'Resumo semanal de vendas',
  'monthly-sales-summary': 'Resumo mensal de vendas',
};

export const REPORT_SUBSCRIPTION_FREQUENCY_LABELS: Record<
  ReportSubscriptionFrequency,
  string
> = {
  daily: 'Diária',
  weekly: 'Semanal',
  monthly: 'Mensal',
};
